import Text from './Text';
import Password from './Password';


export default Text;

export { Password };
